export const SITE_URL = 'https://renekrajnc.com';
